<template>
  <div>
    <v-card class="card">
      <v-card-title>
        Tracked Products
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="products"
        :search="search"
        :items-per-page="5"
        @click:row="itemClick"
      >
        <template v-slot:item.rank="{ item }" >
          <v-chip pill v-if="getIndex(item) <= 3">
              <v-avatar
                  left
                  :class="{ gold: getIndex(item) == 1, argent: getIndex(item) == 2, bronze: getIndex(item) == 3 }"
              >
                <v-icon dark small>mdi-medal</v-icon>
              </v-avatar>
               <span v-if="getIndex(item) == 1">First</span>
               <span v-if="getIndex(item) == 2">Second</span>
               <span v-if="getIndex(item) == 3">Third</span>
          </v-chip>

          
        </template>
        <template v-slot:item.images="{ item }" >
          <div v-if="(item && item.images && item.images.length>0)">
            <v-img
              :src="item.images[0].url"
              alt="No image :("
              aspect-ratio="1"
              max-width="70"
              max-height="70"
              transition="true"
            ></v-img>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ProductSalles -->

    <v-dialog v-model="dialog" max-width="1200px">
        <v-card >
            <v-card-title>
                <span>
                  <v-btn
                    class="ma-3 white--text"
                    rounded icon
                    @click="prevProduct()"
                    :disabled="disablePrev"
                  >
                    <v-icon dark>mdi-chevron-left</v-icon>
                  </v-btn>
                </span>
                <span class="dialog-product-img"> 
                  <v-img
                    :src="selectedProductImg"
                    :lazy-src="imageSrc"
                    alt="No image :("
                    aspect-ratio="1"
                    max-width="50"
                    max-height="50"
                    transition="true"
                  ></v-img>
                </span> 
                <span class="headline">
                  <a class="product-link" v-if="selectedProductAsin" :href="selectedProductAsin" target="_blank">
                    <div class="product-name">
                      Sales of: {{ selectedProductName }}
                    </div>
                  </a> 
                  <div class="product-name" v-else>
                    Sales of: {{ selectedProductName }}
                  </div> 
                </span> 
                <v-spacer></v-spacer>
                <!-- <span>
                    <v-select
                        :items="['0-17', '18-29', '30-54', '54+']"
                        label="By day"
                        required
                        >
                    </v-select>
                </span> -->
                <span>
                  <v-btn
                    class="ma-3 white--text"
                    rounded icon
                    @click="nextProduct()"
                    :disabled="disableNext"
                  >
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </v-btn>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <ProductSalles :productId="productId" :selectedProduct="selectedProduct"/>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
  import ProductSalles from "../components/ProductSales";

  export default {
    name: 'ProductsList',
    data () {
      return {
        search: '',
        dialog: false,
        imageSrc: 'https://via.placeholder.com/50',
        productId: null,
        selectedProduct: null,
        disablePrev: false,
        disableNext: false,
        headers: [
          { text: 'Raking', value: 'rank', width:'5px' },
          { text: 'Photos', value: 'images', width:'70px' },
          { text: 'Title', value: 'name', width:'90px'},
          // { text: 'Price', value: 'price' },
          // { text: 'Qantity', value: 'qt' },
        ],
      }
    },
    components:{
      'ProductSalles': ProductSalles
    },
    methods:{
      itemClick (e) {
        this.dialog = true;
        let itemId = e.id;
        this.selectedProduct = e;
        this.productId = itemId;
      },
      prevProduct (){
        //debugger;
        // Get current product index
        let currentId = this.productId;
        let currentIndex = this.products.findIndex(x => x.id === currentId);

        // Select next Product
        if( currentId && currentIndex - 1 >= 0){
          let id = this.products[currentIndex - 1].id;
          this.productId = id;
          this.selectedProduct = this.products.find(x => x.id === id);
        }else{
          this.disablePrev = true;
        }

        this.disableNext = false;
      },
      nextProduct (){
        //debugger;
        // Get current product index
        let currentId = this.productId;
        let currentIndex = this.products.findIndex(x => x.id === currentId);

        // Select next Product
        if( currentId && currentIndex + 1 < this.products.length  ){
          let id = this.products[currentIndex + 1].id;
          this.productId = id;
          this.selectedProduct = this.products.find(x => x.id === id);
        }else{
          this.disableNext = true;
        }

        this.disablePrev = false;
      },
      closeDialog (){
        this.dialog = false;
        this.selectedProduct = null;
      },
      getIndex ( item ){
        return this.products.indexOf( item ) + 1;
      }
    },
    computed : {
      products (){
        return this.$store.getters.getTrackedProducts;
      },
      trackedProductsLength (){
        return this.$store.getters.getTrackedProducts.length;
      },
      allProductsLength (){
        return this.$store.getters.getAllProducts.length;
      },
      selectedProductName (){
        return ( this.selectedProduct && this.selectedProduct.name )? this.selectedProduct.name:'';
      },
      selectedProductImg (){
        return ( this.selectedProduct && this.selectedProduct.images.length>0 )? this.selectedProduct.images[0].url:'https://via.placeholder.com/50';
      },
      selectedProductAsin (){
        return ( this.selectedProduct && this.selectedProduct.asin )? `https://${this.selectedProduct.marketplace.url}/dp/${this.selectedProduct.asin}`:'https://amazon.com';
      }
    },
    mounted(){
      this.$store.dispatch('GET_PRODUCTS')
    }
  }
</script>

<style scoped>
  tr{
    cursor: pointer;
  }
  .card{
    margin: 12px;
  }
  .dialog-product-img{
    height: 50px; 
    width: 50px; 
    margin-right:5px;
  }
  .product-name{
    text-overflow: ellipsis;
    overflow: hidden; 
    max-width: 860px; 
    height: 1.2em; 
    white-space: nowrap;
    margin-left:5px;
  }
  .product-link{
    color: white;
    text-decoration: none;
  }
  /* chips classes */

  .gold{
    background: #FBC02D;
  }
  .argent{
    background: #78909C;
  }
  .bronze{
    background: #cd7f32;
  }
</style>
